"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.packageFilesReducer = exports.initialState = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* Package Imports */
var connected_react_router_1 = require("connected-react-router");
var typesafe_actions_1 = require("typesafe-actions");
/* Blast Imports */
var actions = __importStar(require("./actions"));
var models_1 = require("@app/_state/models");
var transfersAction = __importStar(require("@app/features/transfers/state/actions"));
exports.initialState = {
    isLoading: false,
    packageFiles: []
};
/* Complimentary Reducer Functions - begin */
var findFile = function (path, files) {
    for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
        var file = files_1[_i];
        if (file.path === path) {
            return file;
        }
        if (file.children) {
            var found = findFile(path, file.children);
            if (found) {
                return found;
            }
        }
    }
};
var findFileByName = function (name, files) {
    for (var _i = 0, files_2 = files; _i < files_2.length; _i++) {
        var file = files_2[_i];
        if (file.name === name) {
            return file;
        }
        if (file.children) {
            var found = findFileByName(name, file.children);
            if (found) {
                return found;
            }
        }
    }
};
var mapToModel = function (files) {
    return files.map(function (f) {
        return {
            name: f.basename,
            path: f.path,
            size: f.size,
            isCollapsed: true,
            isLeaf: f.type === 'file',
            transferredBytes: f.transferInfo ? f.transferInfo.transferredBytes || 0 : 0,
            state: f.transferInfo ? f.transferInfo.transferState : undefined,
            errorCode: f.errorCode,
            errorDesc: f.errorDesc,
            errorMsg: f.errorMsg,
            fileTransferId: f.transferInfo ? f.transferInfo.transferId : undefined
        };
    });
};
var resetFilesTransferState = function (files) {
    for (var _i = 0, files_3 = files; _i < files_3.length; _i++) {
        var file = files_3[_i];
        file.state = undefined;
        if (file.children) {
            file.children = resetFilesTransferState(file.children);
        }
    }
    return files;
};
/**
 * Replaces a file in the provided array with an updated copy
 * @param updatedFile The file to replace
 * @param files The collection to modify
 */
var updateFile = function (updatedFile, files) {
    for (var _i = 0, files_4 = files; _i < files_4.length; _i++) {
        var file = files_4[_i];
        if (file.path === updatedFile.path) {
            var idx = files.findIndex(function (f) { return f.path === updatedFile.path; });
            files.splice(idx, 1, updatedFile);
            return;
        }
        if (file.children) {
            updateFile(updatedFile, file.children);
        }
    }
};
/* Complimentary Reducer Functions - end */
var packageFilesReducer = function (state, action) {
    if (state === void 0) { state = exports.initialState; }
    switch (action.type) {
        // Packages actions
        case typesafe_actions_1.getType(actions.collapseDirectory): {
            var files = __spreadArray([], state.packageFiles);
            var file = findFile(action.payload, state.packageFiles);
            file = __assign(__assign({}, file), { isCollapsed: true });
            updateFile(file, files);
            return __assign(__assign({}, state), { packageFiles: files });
        }
        case typesafe_actions_1.getType(actions.expandDirectoryRequest): {
            var files = __spreadArray([], state.packageFiles);
            var file = findFile(action.payload, state.packageFiles);
            file = __assign(__assign({}, file), { isLoading: true });
            updateFile(file, files);
            return __assign(__assign({}, state), { packageFiles: files });
        }
        case typesafe_actions_1.getType(actions.expandDirectorySuccess): {
            var files = __spreadArray([], state.packageFiles);
            var file = findFile(action.payload.path, state.packageFiles);
            file = __assign(__assign({}, file), { isCollapsed: !action.payload.expandDir, isLoading: false });
            if (action.payload.files) {
                file = __assign(__assign({}, file), { children: mapToModel(action.payload.files) });
            }
            updateFile(file, files);
            return __assign(__assign({}, state), { packageFiles: files });
        }
        case typesafe_actions_1.getType(actions.getPackageFilesRequest):
            return __assign(__assign({}, state), { isLoading: true });
        case typesafe_actions_1.getType(actions.getPackageFilesSuccess):
            return __assign(__assign({}, state), { isLoading: false, packageFiles: mapToModel(action.payload) });
        case typesafe_actions_1.getType(actions.updateFileTransferAction): {
            var files = __spreadArray([], state.packageFiles);
            var file = findFileByName(action.payload.filename, state.packageFiles);
            if (file) {
                file = __assign(__assign({}, file), { size: (file.size === 0) ? action.payload.totalSize : file.size, transferredBytes: action.payload.transferredBytes, state: action.payload.state, fileTransferId: action.payload.transferId, errorCode: action.payload.errorCode, errorDesc: action.payload.errorDesc, errorMsg: (action.payload.state === models_1.PackageTransferState.FAILED) ? 'Error downloading the file' : '' });
                updateFile(file, files);
                return __assign(__assign({}, state), { packageFiles: files });
            }
            else {
                return __assign({}, state);
            }
        }
        // Transfers actions
        case typesafe_actions_1.getType(transfersAction.connectDownloadRequest): {
            if (!action.payload.filePath) {
                return state;
            }
            var files = __spreadArray([], state.packageFiles);
            var file = findFile(action.payload.filePath, state.packageFiles);
            file = __assign(__assign({}, file), { transferredBytes: 0, state: models_1.PackageTransferState.IN_PROGRESS, errorMsg: '' });
            updateFile(file, files);
            return __assign(__assign({}, state), { packageFiles: files });
        }
        case typesafe_actions_1.getType(transfersAction.connectTransferReject): {
            if (!action.payload.filePath) {
                return state;
            }
            var files = __spreadArray([], state.packageFiles);
            var file = findFile(action.payload.filePath, state.packageFiles);
            file = __assign(__assign({}, file), { errorMsg: "Error downloading the file. Retry and 'Allow' connection with Aspera Connect", state: models_1.PackageTransferState.FAILED });
            updateFile(file, files);
            return __assign(__assign({}, state), { packageFiles: files });
        }
        case typesafe_actions_1.getType(transfersAction.downloadReject): {
            if (!action.payload.filePath) {
                return state;
            }
            var files = __spreadArray([], state.packageFiles);
            var file = findFile(action.payload.filePath, state.packageFiles);
            file = __assign(__assign({}, file), { errorMsg: "Error downloading the file", state: models_1.PackageTransferState.FAILED });
            updateFile(file, files);
            return __assign(__assign({}, state), { packageFiles: files });
        }
        case typesafe_actions_1.getType(transfersAction.pluginEvent): {
            var files = __spreadArray([], state.packageFiles);
            var updatedFiles = resetFilesTransferState(files);
            return __assign(__assign({}, state), { packageFiles: updatedFiles });
        }
        // React Router actions
        case connected_react_router_1.LOCATION_CHANGE: {
            return __assign(__assign({}, state), { isLoading: false, packageFiles: [] });
        }
        default:
            return state;
    }
};
exports.packageFilesReducer = packageFilesReducer;
